<template>
  <el-dialog
    title="Account Balance"
    :visible.sync="visible"
    @close="closeDialog"
    class="table"
  >
    <el-row>
      <el-button type="text" class="font-info" icon="el-icon-user"
        >Membership level:</el-button
      >
      <i class="level"> {{ userLevelId }}</i>
    </el-row>
    <el-row>
      <el-button type="text" class="font-info" icon="el-icon-coin"
        >Balance:</el-button
      >
      RM<i class="balance"> {{ balance }} </i>
    </el-row>
  </el-dialog>
</template>

<script>
import { getSessionUser } from "@/api/auth";

// 会员等级映射
const VIP_LEVEL_MAP = new Map([
  [2, "Standard VIP"],
  [4, "Senior VIP"],
  [5, "Enterprise VIP"],
]);

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val;
        if (val) this.getUserList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      visible: false,
      balance: 0,
      userLevelId: "-",
    };
  },
  methods: {
    async getUserList() {
      try {
        const result = await getSessionUser({});
        if (!result) return;

        this.balance = result.blance;

        // 检查VIP是否过期并设置等级
        if (result.userLevelId && new Date() <= new Date(result.vipEndTime)) {
          this.userLevelId = VIP_LEVEL_MAP.get(result.userLevelId) || "-";
        }
      } catch (error) {
        console.error("Get user error:", error);
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.font-info {
  color: #3e3e3e;
}
.font-warning {
  color: #e6a23c;
}
.level {
  font-size: 12px;
  color: #e6a23c;
  margin-top: 6px;
  font-size: 24px;
}
.balance {
  font-size: 12px;
  color: #409eff;
  margin-top: 6px;
  font-size: 24px;
}
</style>
